module.exports = __webpack_public_path__ + "img/portfolio--agency-03.02bdce83.jpg";